import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

const isDayBetween = (
  startBoundary: Date | string,
  endBoundary: Date | string,
  day: Date | string,
): boolean =>
  dayjs(day)
    .startOf('day')
    .isBetween(
      dayjs(startBoundary).startOf('day'),
      dayjs(endBoundary).startOf('day'),
      undefined,
      '[]',
    );

export { isDayBetween };
